import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const TarjetaContador = ({
  titulo = "Título",
  valor = 0,
  descripcion = null,
  icono = null,
  ruta = "/",
  loading = false,
  disabled = false,
  onClick = null,
  sx = {},
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (disabled || loading) return;
    if (onClick) onClick();
    else navigate(ruta);
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        cursor: disabled || loading ? "not-allowed" : "pointer",
        userSelect: "none",

        backgroundColor: "#ffffff",
        borderRadius: 3,
        padding: 3,
        border: "1px solid rgba(0,0,0,0.1)",
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",

        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1.5,
        minWidth: 180,
        transition: "all 0.25s ease",

        "&:hover": {
          boxShadow:
            disabled || loading
              ? "0 2px 8px rgba(0,0,0,0.06)"
              : "0 6px 20px rgba(0,0,0,0.12)",
          transform: disabled || loading ? "none" : "translateY(-3px)",
        },

        ...sx,
      }}
    >
      {loading ? (
        <CircularProgress size={32} />
      ) : (
        <>
          {icono && (
            <Box sx={{ fontSize: "2.6rem", color: "rgba(0,0,0,0.65)" }}>
              {icono}
            </Box>
          )}

          {/* Número grande */}
          <Typography
            variant="h2"
            sx={{
              fontWeight: 700,
              color: "rgba(0,0,0,0.85)",
              lineHeight: 1,
              textAlign: "center",
              fontSize: "3rem",
            }}
          >
            {valor}
          </Typography>

          {/* Texto principal */}
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: "rgba(0,0,0,0.8)",
              textAlign: "center",
            }}
          >
            {titulo}
          </Typography>

          {/* Descripción opcional */}
          {descripcion && (
            <Typography
              variant="body2"
              sx={{ color: "rgba(0,0,0,0.55)", textAlign: "center" }}
            >
              {descripcion}
            </Typography>
          )}
        </>
      )}
    </Box>
  );
};

export default TarjetaContador;
